import api from './api';

export const uploadService = {
  uploadCertificate: async (certificateData) => {
    try {
      // Validazione dei dati obbligatori
      if (!certificateData.userId) {
        return {
          success: false,
          message: 'UserId è richiesto'
        };
      }

      // Converte le date in formato ISO se necessario
      const convertToISOString = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('T')) {
          return dateInput; // Già in formato ISO
        }
        const date = new Date(dateInput);
        return date.toISOString();
      };

      // Se c'è un file, usa multipart, altrimenti JSON normale
      if (certificateData.file && certificateData.file !== null) {
        const formData = new FormData();
        formData.append('userId', certificateData.userId);
        if (certificateData.certificateNumber) {
          formData.append('certificateNumber', certificateData.certificateNumber);
        }
        formData.append('issueDate', convertToISOString(certificateData.issueDate));
        formData.append('expiryDate', convertToISOString(certificateData.expiryDate));
        formData.append('certificateType', certificateData.certificateType);
        if (certificateData.notes) {
          formData.append('notes', certificateData.notes);
        }
        formData.append('file', certificateData.file);

        const response = await api.post('/api/medical-certificates', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        return {
          success: true,
          data: response.data,
          message: 'Certificato medico e file caricati con successo'
        };
      } else {
        // Richiesta JSON normale senza file
        const response = await api.post('/api/medical-certificates', {
          userId: certificateData.userId,
          certificateNumber: certificateData.certificateNumber || null,
          issueDate: convertToISOString(certificateData.issueDate),
          expiryDate: convertToISOString(certificateData.expiryDate),
          certificateType: certificateData.certificateType,
          notes: certificateData.notes || null
        });

        return {
          success: true,
          data: response.data,
          message: 'Certificato medico creato con successo'
        };
      }
    } catch (error) {
      console.error('Error in uploadCertificate:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Errore di connessione al server'
      };
    }
  },

  updateCertificate: async (certificateId, certificateData) => {
    try {
      // Validazione dei dati obbligatori
      if (!certificateId) {
        return {
          success: false,
          message: 'ID certificato è richiesto'
        };
      }

      // Converte le date in formato ISO se necessario
      const convertToISOString = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('T')) {
          return dateInput; // Già in formato ISO
        }
        const date = new Date(dateInput);
        return date.toISOString();
      };

      // Se c'è un file, usa multipart, altrimenti JSON normale
      if (certificateData.file && certificateData.file !== null) {
        const formData = new FormData();
        if (certificateData.certificateNumber !== undefined) {
          formData.append('certificateNumber', certificateData.certificateNumber || '');
        }
        if (certificateData.issueDate) {
          formData.append('issueDate', convertToISOString(certificateData.issueDate));
        }
        if (certificateData.expiryDate) {
          formData.append('expiryDate', convertToISOString(certificateData.expiryDate));
        }
        if (certificateData.certificateType) {
          formData.append('certificateType', certificateData.certificateType);
        }
        if (certificateData.notes !== undefined) {
          formData.append('notes', certificateData.notes || '');
        }
        formData.append('file', certificateData.file);

        const response = await api.put(`/api/medical-certificates/${certificateId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        return {
          success: true,
          data: response.data,
          message: 'Certificato medico e file aggiornati con successo'
        };
      } else {
        // Richiesta JSON normale senza file
        const response = await api.put(`/api/medical-certificates/${certificateId}`, {
          certificateNumber: certificateData.certificateNumber || null,
          issueDate: certificateData.issueDate ? convertToISOString(certificateData.issueDate) : null,
          expiryDate: certificateData.expiryDate ? convertToISOString(certificateData.expiryDate) : null,
          certificateType: certificateData.certificateType || null,
          notes: certificateData.notes !== undefined ? certificateData.notes : null
        });

        return {
          success: true,
          data: response.data,
          message: 'Certificato medico aggiornato con successo'
        };
      }
    } catch (error) {
      console.error('Error in updateCertificate:', error);
      return {
        success: false,
        message: error.response?.data?.message || "Errore nell'aggiornamento del certificato medico"
      };
    }
  },

  updateDocument: async (documentId, documentData) => {
    try {
      // Validazione dei dati obbligatori
      if (!documentId) {
        return {
          success: false,
          message: 'ID documento è richiesto'
        };
      }

      // Se c'è un file, usa multipart, altrimenti JSON normale
      if (documentData.file && documentData.file !== null) {
        const formData = new FormData();
        if (documentData.title !== undefined) formData.append('title', documentData.title);
        if (documentData.description !== undefined) formData.append('description', documentData.description || '');
        if (documentData.documentType !== undefined) formData.append('documentType', documentData.documentType || '');
        if (documentData.category !== undefined) formData.append('category', documentData.category || '');
        formData.append('file', documentData.file);

        const response = await api.put(`/api/documents/${documentId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        return {
          success: true,
          data: response.data,
          message: 'Documento e file aggiornati con successo'
        };
      } else {
        // Richiesta JSON normale senza file
        const response = await api.put(`/api/documents/${documentId}`, {
          title: documentData.title || null,
          description: documentData.description || null,
          documentType: documentData.documentType || null,
          category: documentData.category || null
        });

        return {
          success: true,
          data: response.data,
          message: 'Documento aggiornato con successo'
        };
      }
    } catch (error) {
      console.error('Error in updateDocument:', error);
      return {
        success: false,
        message: error.response?.data?.message || "Errore nell'aggiornamento del documento"
      };
    }
  },

  uploadDocument: async (documentData) => {
    try {
      const formData = new FormData();
      formData.append('relatedUser', documentData.userId || documentData.relatedUser);
      formData.append('title', documentData.title);
      if (documentData.description) formData.append('description', documentData.description);
      if (documentData.documentType) formData.append('documentType', documentData.documentType);
      formData.append('category', documentData.category || 'general');
      formData.append('file', documentData.file);

      const response = await api.post('/api/documents', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Documento e file caricati con successo'
      };
    } catch (error) {
      console.error('Error in uploadDocument:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Errore di connessione al server'
      };
    }
  }
};

export default uploadService;
